import { render, staticRenderFns } from "./SnapshotOverview.vue?vue&type=template&id=c2deb1f4&"
import script from "./SnapshotOverview.vue?vue&type=script&lang=js&"
export * from "./SnapshotOverview.vue?vue&type=script&lang=js&"
import style0 from "./SnapshotOverview.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports